import { Component, ElementRef, inject, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CheckboxModule } from 'primeng/checkbox';

@Component({
  selector: 'selectable-widget',
  standalone: true,
  imports: [CheckboxModule, FormsModule],
  template: `
    <ng-content />
    @if (exportMode()) {
      <div
        data-export-overlay
        class="absolute inset-0 z-10 cursor-pointer rounded border-2 border-secondary-200 bg-secondary-50/40 transition-colors hover:bg-secondary-100/50">
        <p-check-box
          binary="true"
          class="absolute left-3 top-2"
          [ngModel]="selected()"
          (onChange)="widgetToggle.emit($event.checked)" />
      </div>
    }
  `,
  host: {
    class: 'relative',
    'data-widget': '',
  },
})
export class SelectableWidget {
  readonly nativeEl: HTMLElement = inject(ElementRef).nativeElement;

  exportMode = input<boolean>(false);
  selected = input<boolean>(false);
  widgetToggle = output<boolean>();
}
